<template>
  <Modal class="setting-modal" width="650px" @open="handleOpen" :btns="[]">
    <template #title>
      <div v-if="initTab === 'account'" class="tabs">
        <div :class="{ active: current === 'account' }" @click.stop="current = 'account'">
          账户设置
        </div>
      </div>
      <div v-else class="tabs">
        <div
          value="member"
          :class="{ active: current === 'member' }"
          @click.stop="current = 'member'"
        >
          成员列表
        </div>
        <div
          value="member"
          :class="{ active: current === 'seat' }"
          @click.stop="current = 'seat'"
        >
          席位设置
        </div>
        <div
          value="enterprise"
          :class="{ active: current === 'enterprise' }"
          @click.stop="current = 'enterprise'"
        >
          团队设置
        </div>
      </div>
    </template>
    <AccountSetting v-if="current === 'account'"></AccountSetting>
    <SeatSetting v-else-if="current === 'seat'"></SeatSetting>
    <MemberManageNew v-else-if="current === 'member'"></MemberManageNew>
    <EnterpriseSettingNew @close="emit('close')" v-else></EnterpriseSettingNew>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@elecmap/elecmap-ui'
import { reactive, ref } from 'vue'
import AccountSetting from './account-setting.vue'
import MemberManageNew from './member-manage-new.vue'
import EnterpriseSettingNew from './enterprise-setting-new.vue'
import SeatSetting from './seat-setting.vue'

const props = defineProps<{
  initTab: 'account' | 'member' | 'seat' | 'enterprise'
}>()

const emit = defineEmits(['close'])

const current = ref('account')
function handleOpen() {
  current.value = props.initTab
}
</script>

<style lang="less">
.setting-modal {
  .ant-modal-content {
    height: 70vh !important;
    min-height: 850px !important;
  }
  .ant-modal-header {
    padding: 0 !important;
    height: 48px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6 !important;
  }
  .ant-modal-body {
    padding: 24px 32px 0 !important;
    overflow-y: auto;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-close-x {
    position: absolute;
    width: 24px;
    height: 24px;
    line-height: 24px;
    right: 12px;
    top: 8px;
  }

  .tabs {
    display: flex;
    margin-left: 32px;
    > div {
      cursor: pointer;
      color: rgba(0, 0, 0, 0.5);
      transition: all 0.2s;
      padding: 0 8px;
      height: 24px;
      line-height: 24px;
      border-radius: 0.3125rem;
      margin-right: 8px;
      &:hover {
        color: rgba(0, 0, 0, 0.9);
      }
      &.active {
        background: #f5f5f5;
        color: rgba(0, 0, 0, 0.9);
      }
    }
  }
}
</style>
